import { pipe } from "lib/functional";
import { tileServices } from "lib/tileServices";
import _ from "lodash";

const getTileServers = (overlay) => {
  if (overlay.mapboxTiles) {
    return overlay.mapboxTiles;
  }

  return pipe(
    // add https
    (url) => (url.startsWith("//") ? `https:${url}` : url),
    // add /{z}/{x}/{y}.png
    (url) => (!url.includes("{z}") ? `${url}{z}/{x}/{y}.png` : url),
    // append key
    (url) => (overlay.key ? `${url}?apikey=${overlay.key}` : url),
    // transform {s}, return array
    (url) => (url.includes("{s}") ? ["a", "b", "c"].map((s) => url.replace("{s}", s)) : [url])
  )(overlay.url);
};

// convert tileServices to mapbox sources spec
// the o && o.type is important because ie11 imports the tileServices object
// with weird react keys instead of as a plain js object, which caused
// https://github.com/ridewithgps/ridewithgps/issues/8439
const notGoogle = _.pickBy(tileServices, (o) => o && o.type !== "google");
const sources = _.mapValues(notGoogle, (overlay) => ({
  type: "raster",
  tiles: getTileServers(overlay),
  tileSize: overlay.tileSize || 256,
  attribution: overlay.attribution,
}));

export const getMapboxStyle = (initialOverlay) => ({
  version: 8,
  sources,
  layers: [
    {
      id: "raster-basemap",
      type: "raster",
      source: initialOverlay.id,
      minzoom: initialOverlay.minZoom,
      maxZoom: initialOverlay.maxZoom,
    },
  ],
});
